import React, { useState, useEffect } from 'react';
import { Col, Row } from '../../../../../components/base/BootstrapComponents/BootstrapComponents';
import FieldDTOWithCol from '../../../../../components/fields/Abstract/FieldDTOWithCol';
import TextInputWithLabel from '../../../../../components/fields/TextInput/TextInputWithLabel';
import Switches from '../../../../../components/fields/Switches/Switches';
import { companyNameTransform } from '../../../../../utils/utils';
import JuridicalDTO from '../../../../../dto/JuridicalDTO';
import { PROCEDURE_TYPE, USER_TYPE } from '../../../../../configs';
import FieldDTO from '../../../../../components/fields/Abstract/FieldDTO';
import SelectInputWithHelper from '../../../../../components/fields/SelectInput/SelectInputWithHelper';
import { loadLegalEntityFormList } from '../../../actions';
import FileInput from '../../../../../components/fields/FileInput/FileInput';
import AddressInput from '../../../../../components/fields/Address/AddressInput';

export default function ReorganizationJuridicalForm(props) {
  const {
    prefix = 'applicant_new.', control, formMeta, applicantType, procedure, setValue, currentApplication, isEdit, getValues,
  } = props;

  const [showFullName, setShowFullName] = useState(isEdit ? !!currentApplication?.applicant_new?.full_name || currentApplication?.applicant_new?.full_name === null : false);
  const [showShortName, setShowShortName] = useState(isEdit ? !!currentApplication?.applicant_new?.short_name || currentApplication?.applicant_new?.short_name === null : false);
  const [showInn, setShowInn] = useState(isEdit ? !!currentApplication?.applicant_new?.inn || currentApplication?.applicant_new?.inn === null : false);
  const [showOgrn, setShowOgrn] = useState(isEdit ? !!currentApplication?.applicant_new?.ogrn || currentApplication?.applicant_new?.ogrn === null : false);
  const [showLegalAddress, setShowLegalAddress] = useState(isEdit ? !!currentApplication?.applicant_new?.legal_address || currentApplication?.applicant_new?.legal_address === null : false);
  const [showAddress, setShowAddress] = useState(isEdit ? !!currentApplication?.applicant_new?.address || currentApplication?.applicant_new?.address === null : false);

  const dto = new JuridicalDTO({ optional: true, legal_entity_type: applicantType });
  const attributes = dto.getAttributesByName();

  useEffect(() => {
    setValue('applicant_new.full_name', !showFullName ? null : (isEdit ? getValues('applicant_new.full_name') || '' : ''));
  }, [showFullName]);

  useEffect(() => {
    setValue('applicant_new.short_name', !showShortName ? null : (isEdit ? getValues('applicant_new.short_name') || '' : ''));
  }, [showShortName]);

  useEffect(() => {
    setValue('applicant_new.inn', !showInn ? null : (isEdit ? getValues('applicant_new.inn') || '' : ''));
  }, [showInn]);

  useEffect(() => {
    setValue('applicant_new.ogrn', !showOgrn ? null : (isEdit ? getValues('applicant_new.ogrn') || '' : ''));
  }, [showOgrn]);

  useEffect(() => {
    setValue('applicant_new.legal_address', !showLegalAddress ? null : (isEdit ? getValues('applicant_new.legal_address') || '' : ''));
  }, [showLegalAddress]);

  useEffect(() => {
    // eslint-disable-next-line no-unused-expressions
    !showAddress
      ? (setValue('applicant_new.address', null), setValue('media.identity_change_document', null))
      : setValue('applicant_new.address', isEdit ? getValues('applicant_new?.address') || '' : '');
  }, [showAddress]);

  if (!([PROCEDURE_TYPE.PROCEDURE_1227_3, PROCEDURE_TYPE.PROCEDURE_1227_5, PROCEDURE_TYPE.PROCEDURE_1227_8, PROCEDURE_TYPE.PROCEDURE_1228_3].includes(procedure) && applicantType === USER_TYPE.LEGAL)) return null;

  return (
    <>
      {![PROCEDURE_TYPE.PROCEDURE_1227_8].includes(procedure) && (<div className="f3 mt-3">Реорганизация юридического лица</div>)}
      {[PROCEDURE_TYPE.PROCEDURE_1227_3, PROCEDURE_TYPE.PROCEDURE_1227_8, PROCEDURE_TYPE.PROCEDURE_1228_3].includes(procedure) && (
        <>
          <div className="f4 mt-3">Изменилось полное и сокращенное (при наличии) наименование (на русском языке)</div>
          {![PROCEDURE_TYPE.PROCEDURE_1227_8].includes(procedure) && (
            <Row className="row-cols-1">
              <FieldDTO
                control={control}
                component={SelectInputWithHelper}
                dtoObject={attributes.legal_entity_form}
                namePrefix={prefix}
                portalClassName="executor-selector"
                loadAction={loadLegalEntityFormList}
                optionFormatter={item => ({ value: item.full_name, name: item.full_name })}
                variant="material"
                type="text"
                labelPrefix="new."
                withLabel
              />
            </Row>
          )}
          <Row className="row-cols-1">
            <Col>
              <Switches
                type="text"
                variant="material"
                inputProps={{
                  onChange: () => setShowFullName(!showFullName),
                  value: showFullName,
                }}
                label="Изменилось полное наименование (на русском языке)"
              />
            </Col>
          </Row>
          {showFullName && (
            <Row className="row-cols-1">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.full_name}
                transform={companyNameTransform}
                variant="material"
                namePrefix={prefix}
                labelPrefix="new."
              />
            </Row>
          )}
          <Row className="row-cols-1">
            <Col>
              <Switches
                type="text"
                variant="material"
                inputProps={{
                  onChange: () => setShowShortName(!showShortName),
                  value: showShortName,
                }}
                label="Изменилось сокращённое наименование (на русском языке)"
              />
            </Col>
          </Row>
          {showShortName && (
            <Row className="row-cols-1">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.short_name}
                transform={companyNameTransform}
                variant="material"
                namePrefix={prefix}
                labelPrefix="new."
              />
            </Row>
          )}
        </>
      )}
      {[PROCEDURE_TYPE.PROCEDURE_1227_3, PROCEDURE_TYPE.PROCEDURE_1228_3].includes(procedure) && (
        <>
          <div className="f4 mt-3">Изменился ИНН и/или ОГРН</div>
          <Row className="row-cols-1">
            <Col>
              <Switches
                type="text"
                variant="material"
                inputProps={{
                  onChange: () => setShowInn(!showInn),
                  value: showInn,
                }}
                label="Изменился ИНН"
              />
            </Col>
          </Row>
          {showInn && (
            <Row className="row-cols-1">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.inn}
                variant="material"
                namePrefix={prefix}
                labelPrefix="new."
              />
            </Row>
          )}
          <Row className="row-cols-1">
            <Col>
              <Switches
                type="text"
                variant="material"
                inputProps={{
                  onChange: () => setShowOgrn(!showOgrn),
                  value: showOgrn,
                }}
                label="Изменился ОГРН"
              />
            </Col>
          </Row>
          {showOgrn && (
            <Row className="row-cols-1">
              <FieldDTOWithCol
                control={control}
                formMeta={formMeta}
                type="text"
                component={TextInputWithLabel}
                dtoObject={attributes.ogrn}
                variant="material"
                namePrefix={prefix}
                labelPrefix="new."
              />
            </Row>
          )}
        </>
      )}
      <div className="f4 mt-3">Изменился юридический адрес и/или адрес местонахождения</div>
      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => setShowLegalAddress(!showLegalAddress),
              value: showLegalAddress,
            }}
            label="Изменился юридический адрес"
          />
        </Col>
      </Row>
      {showLegalAddress && (
        <Row className="row-cols-1">
          <FieldDTOWithCol
            control={control}
            formMeta={formMeta}
            type="text"
            component={AddressInput}
            dtoObject={attributes.legal_address}
            variant="material"
            namePrefix={prefix}
            labelPrefix="new."
          />
        </Row>
      )}
      <Row className="row-cols-1">
        <Col>
          <Switches
            type="text"
            variant="material"
            inputProps={{
              onChange: () => setShowAddress(!showAddress),
              value: showAddress,
            }}
            label="Изменился адрес местонахождения"
          />
        </Col>
      </Row>
      {showAddress && (
        <>
          <Row className="row-cols-1">
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={AddressInput}
              dtoObject={attributes.address}
              variant="material"
              namePrefix={prefix}
              labelPrefix="new."
            />
          </Row>
          <Row className="row-cols-1">
            <FieldDTOWithCol
              control={control}
              formMeta={formMeta}
              type="text"
              component={FileInput}
              dtoObject={attributes.identity_change_document}
              variant="material"
              namePrefix="media."
            />
          </Row>
        </>
      )}
      <div className="hr-row mt-3" />
    </>
  );
}
